(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["astroida-box-gift-animation"] && !Shopify.designMode) return;
  try {
    (function () {
    var notice = document.getElementById('AstroidaBoxGiftAnimation');
    if (!notice || notice.dataset.installed === 'true') return;
    notice.dataset.installed = 'true';
    var variantIds = JSON.parse(notice.dataset.variantIds || '[]').map(String);
    var message = notice.querySelector('[data-box-gift-message]');
    var hideTimer;
    var clearTimer;
    var waitTimer;

    function hide() {
      window.clearTimeout(hideTimer);
      notice.classList.remove('is-visible');
      clearTimer = window.setTimeout(function () {
        notice.hidden = true;
        message.textContent = '';
      }, 220);
    }

    function show() {
      window.clearTimeout(hideTimer);
      window.clearTimeout(clearTimer);
      notice.hidden = false;
      notice.classList.remove('is-visible');
      message.textContent = notice.dataset.message;
      void notice.offsetWidth;
      notice.classList.add('is-visible');
      hideTimer = window.setTimeout(hide, 3000);
    }

    function waitForOtherNotice(startedAt) {
      var duplicate = document.getElementById('AstroidaDuplicateNotice');
      var loading = document.querySelector('.pharmacist-touch-overlay.is-active');
      if ((duplicate && !duplicate.hidden) || loading) {
        if (Date.now() - startedAt < 6000) {
          waitTimer = window.setTimeout(function () { waitForOtherNotice(startedAt); }, 150);
        }
        return;
      }
      show();
    }

    document.addEventListener('astroida:cart-add-success', function (event) {
      var items = event.detail && event.detail.items;
      if (!Array.isArray(items)) return;
      var addedBox = items.some(function (item) {
        return Number(item.quantity) > 0 && variantIds.indexOf(String(item.id)) !== -1;
      });
      if (!addedBox) return;
      window.clearTimeout(waitTimer);
      waitForOtherNotice(Date.now());
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !notice.hidden) hide();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
